import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule  } from "@angular/common";
import { Router } from "@angular/router";
import { PrimeNGSharedModule } from "@shared/prime/prime-ng.module";

@Component({
  selector: "app-manage-assessment-success-popup",
  standalone: true,
  imports: [CommonModule, PrimeNGSharedModule ],
  templateUrl: "./manage-assessment-success-popup.component.html",
  styleUrls: ["./manage-assessment-success-popup.component.scss"],
})
export class ManageAssessmentSuccessPopupComponent {
  constructor(private router: Router) {}

  showNewRCADialog: boolean = false;
  
  @Input() visible: boolean = false;
  @Input() data: {
    isSuccess: boolean;
    title: string;
    message: string;
  } = {
    isSuccess: true,
    title: "",
    message: "New RCA Created Successfully",
  };

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeDialog = new EventEmitter<void>();

  ngOnInit(): void {
  }

  close(): void {
    this.closeDialog.emit();
  }

}

